import { trackSubmission } from "components/common/GTMProvider";
import links from "data/links.json";
import { getGTMProps, Pages } from "types/common";

type LinkType = "disclaimer" | "contactus";

// Generates an absolute URL based on the page
export const generateLink = (type: LinkType, page: Pages) => {
  /*
  const location =
    window.top?.location || window.parent?.location || window.location;
  const { href, hash } = location;
  const url = hash ? href.replace(hash, "") : href;
  */
  const url = links.domain + links.prefix + links.path[page];
  return `${url}#${type}`;
};

export const handleLinkClick = (
  e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  page: Pages,
  userId?: number | null,
) => {
  e.preventDefault();
  const fullPath = e.currentTarget.href;

  if (fullPath.endsWith("#contactus")) {
    const gtmProps = getGTMProps(page);

    trackSubmission({
      formId: `gcb_${userId}`,
      label: "speak_to_us",
      ...gtmProps,
    });
  }

  if (window.top) {
    // Navigate parent frame
    window.top.location.href = fullPath;
  } else {
    // Fallback: Open new tab
    window.open(fullPath);
  }
};
